import { lazy } from 'react';
export function lazyWithPreload(factory) {
  const Component = /*#__PURE__*/lazy(factory);
  Component.preload = factory;
  return Component;
}

/**
 * Creates a typed component registry entry. Pass the wire-string union as
 * an explicit generic to enforce exhaustiveness — every wire string must
 * have a matching component.
 *
 * @example
 * type WireStrings = (typeof TYPES)[keyof typeof TYPES];
 * createComponentRegistry<WireStrings>('NS', { NS_GTKM_CARD: lazyComponent });
 */
export function createComponentRegistry(namespace, components) {
  return {
    namespace,
    components
  };
}